// src/utils/marketCalendar.js
export const MARKET_SCHEDULE = {
  default: {
    open: "09:30",
    close: "16:00",
  },

  // YYYY-MM-DD overrides
  overrides: {
    "2026-11-27": { open: "09:30", close: "13:00" }, // Black Friday (example)
    "2026-07-03": { open: "09:30", close: "13:00" }, // Early close
  },

  holidays: [
    "2026-01-01",
    "2026-01-19",
    "2026-12-25"
  ],
};
